import { RiDownloadCloudLine } from "react-icons/ri";
import { Button as MaterialButton } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Col,
  List,
  message,
  Modal,
  Row,
  Select,
  Skeleton,
  Typography,
} from "antd";
import { cards } from "./items";
import { Card } from "../Exterior/Cards";
import Button from "../../components/Button";
import { Page } from "../../constants/brokers";
import { useAuth } from "../../contexts/AuthContext";
import apiBolsa from "../../services/apiBolsa";
import { useBroker } from "../../contexts/BrokerContext";
import { BackButton } from "../../components/BackButton";
import { ReportContainer, Container, Content } from "./styles";
import {
  download,
  errorMessage,
  getInitialYear,
  isMobile,
  monthsExtended,
  zero,
} from "../../utils";
import apiExterior from "../../services/apiExterior";
import { ModalConfirmMail } from "../../components/ModalConfirmMail";
import { UserPlanEnum } from "../../constants/plans";
import { useWebSocket } from "../../contexts/Notification.context";
import { AiOutlineLock } from "react-icons/ai";
import AntButton from "../../components/Button";

interface ReportProps {
  item: Page;
}

export const ReportAlertTitle = (
  <Typography
    style={{
      fontSize: "14px",
      display: "flex",
      columnGap: "8px",
      lineHeight: "18px",
      alignItems: "flex-start",
    }}
  >
    <InfoCircleOutlined style={{ fontSize: "16px", marginTop: "2px" }} />{" "}
    <span>
      Os relatórios estão disponíveis somente no plano premium.{" "}
      <strong>Contrate o seu plano</strong>
    </span>
  </Typography>
);

export const ReportExterior: React.FC<ReportProps> = ({ item }) => {
  const navigate = useNavigate();
  const {
    showUserPlanModal,
    userPlanModal,
    ssoToken,
    hasPlan,
    hasPermissionExteriorPlanos,
    hasPermissionGeneral,
    user,
    updateUserInfo
  } = useAuth();
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const [initialYear, setInitialYear] = useState(currentYear);
  window.history.replaceState({}, document.title);

  const { currentPage } = useBroker();

  const [action, setAction] = useState<string>('anual-report');
  //const [action, setAction] = useState<string>();

  const [data, setData] = useState<any[]>();
  const [infoModal, toggleModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(true);
  const { report, setReport } = useWebSocket();

  const [loadingLinks] = useState(false);
  const [year, setYear] = useState(initialYear);

  const [reportDisabled, setReportDisabled] = useState<boolean>(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [itemToReport, setItemToReport] = useState<any>();
  const historicFeature = item.features[0];
  const downloadFeature = item.features[1];
  // const sendEmailFeature = item.features[2];
  const transactionsFeature = item.features[3];
  const darfFeature = item.features[4];

  const yearOptions = Array.from(Array(initialYear - 2020 + 1))
    .map((y, i) => ({
      value: 2020 + i,
      label: `${2020 + i}`,
    }))
    .reverse();

  const onChangeYear = (value: string) => {
    setYear(parseInt(value));
  };

  const getHistoric = useCallback(() => {
    if (!action) return;
    if (action === "anual-report")
      return setData(
        Array.from(Array(new Date().getFullYear() - 2022))
          .map((y, i) => ({
            year: 2022 + i,
            label: `${2022 + i}`,
          }))
          .reverse()
      );

    setLoading(true);
    (currentPage?.api || apiBolsa)
      .get(`${historicFeature.apiUrl}/${action || "gain"}`, {
        params: { year },
      })
      .then((response) => {
        const data = (response.data ?? []).reverse();
        setData(data);
        // getDowloadLinks(data, action || "gain");
      })
      .catch(() => message.error(errorMessage))
      .finally(() => setLoading(false));
  }, [historicFeature, year, currentPage, action /*, getDowloadLinks*/]);

  useEffect(()=> {
    if (report) {
      const mobileAction = isMobile()
      if (!mobileAction) {
        download(report);
      }
      toggleModal(null);
      setLoading(false);
      setReport("");
    }
  }, [report])
  
  const downloadAction = (sendEmail: boolean): Promise<void> => {
    const act = itemToReport?.action || action;
    setLoading(true);
    const mobileAction = isMobile();

    if (mobileAction) {
      message.info("Preparando seu relatório.");
    } else {
      message.info("Iniciando download do seu relatório.");
    }

    return apiBolsa
      .post(`${downloadFeature.apiUrl}/`, {
        cpf: user.user.cpf,
        userId: user.user.userId,
        provider: "veloprime",
        month: itemToReport.month,
        year: itemToReport.year,
        type: (act === "anual-report") ? "ext-anual" : "",
        sendEmail: mobileAction ? true : sendEmail,
        isPro: false
      })
      .then((res) => {
        if (!res?.data?.status) {
          message.error(res?.data?.message)
          return;
        }
      })
      .catch(({ response }) =>
        message.error(response?.data?.message ?? errorMessage)
      )
  };

  const downloadDarf = async (data: any) => {
    setLoading(true);

    (currentPage?.api || apiBolsa).post(`${darfFeature.apiUrl}`, data)
      .then((res) => {
        if (!res?.data?.darfUrl ) {
          return message.error("Houve um erro ao baixar seu relatório!")
        }
        download(res.data.darfUrl);
        message.success("Relatório emitido com sucesso");
      })
      .catch(({ response }) =>
        message.error(response?.data?.message)
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePlanModal = () => {
    showUserPlanModal(!userPlanModal, ReportAlertTitle);
  };

  const checkDarf = (record: any) => {
    setLoading(true);
    (currentPage?.api || apiBolsa).get(`${transactionsFeature.apiUrl}`, { params: { year: record.year} })
    .then((res) => {
      const darf = res.data.find((d: any)=> {
        if (record?.month == d?.month) return d;
      })
      if (!darf || !darf?._id) {
        message.info("Cliente não possui relatório para este mês.");
        setLoading(false);
        return;
      }
      delete darf?.transactions;
      const data = {
        ...darf,
        year: record.year,
        month: record.month,
        name: user?.user?.name,
        memoriaCalculo: [],
        justSave: false,
        payed: false,
        noSendMail: true,
        paymentInfo: {
          clientInfo: {
            name: user?.user?.name,
            email: user?.user?.email,
            document: user?.user?.cpf,
          },
        },
      };
      setLoading(false);
      downloadDarf(data);
    })
    .catch(({ response }) => {
      const { data, status } = response;
      if (status === 401) message.error(data?.message);
      setLoading(false);
    });
  }

  const handleActionButton = (id: string) => {
    setAction(id);
    switch (id) {
      case "anual-report":
      case "income":
        setYear(2023);
        setInitialYear(2023);
        break;
      case "gain":
        setYear(2024);
        setInitialYear(2024);
        break;
    }
  };

  const handleActionButtonBack = (id: any) => {
    setAction(id);
  };

  const getErrors = () => {
    apiExterior
      .get(`/transaction/hasError`, { params: { notified: true } })
      .then((res: any) => {
        setReportDisabled((res?.data?.error?.errorDates || []).length > 0)
      })
      .catch(() => {
        console.log("Erro no error");
      })
      .finally(() => setLoadingError(false))
  }

  useEffect(() => {
    getErrors()
  }, [])

  useEffect(() => {
    getHistoric();
  }, [getHistoric, year]);

  return (
    <ReportContainer>
      <div className="content">
        <Typography.Title level={1}>Relatórios auxiliares</Typography.Title>
        {action == "anual-report" &&
          <Typography.Paragraph>
             Confira os relatórios auxiliares de operações no exterior para a
             declaração do seu IR.
          </Typography.Paragraph>
        }

        {loadingError ? <LoadingOutlined /> : reportDisabled ?
          <div style={{width: '100%', display: 'flex', marginBottom: '1rem', padding: isMobile() ? '0 24px' : ''}}>
            <Typography.Text style={{fontSize: isMobile() ? '14px' : '16px'}}>
              Não foi possível carregar seu relatório. Verifique se você preencheu o custo médio de compra para os seus ativos de <Link to='/velotax/transferencia-custodia'>Transferência de Custódia</Link>.
            </Typography.Text>
          </div>
          : !action && (
            <div className="cards">
              {cards.map((item) => (
                <Card
                  id={item.id}
                  key={item.id}
                  disabled={
                    loading ||
                    (hasPermissionExteriorPlanos && item.id !== "anual-report")
                  }
                  icon={loading ? <LoadingOutlined /> : item.icon}
                  onClick={() => {
                    if (!hasPlan && !hasPermissionGeneral) {
                     return navigate("/planos");
                    }

                    // if (user?.user?.userPlanInfoVelotax?.type?.includes('BASIC') ||
                    //     user?.user?.userPlanInfoVelotax?.type === UserPlanEnum.XP_BASIC ||
                    //     user?.user?.userPlanInfoVelotax?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) {
                    //   return navigate("/planos");
                    // }

                    !loading && handleActionButton(item.id)
                  }}
                >
                  {item.id === "irpf" ? (
                    <>
                      <a
                        {...(!isMobile() ? { target: "_blank" } : {})}
                        href={
                          !process.env.REACT_APP_NODE_ENV?.includes("dev")
                            ? `https://irpf.velotax.com.br/p/sso/${ssoToken}`
                            : `https://irpfdev.velotax.com.br/p/sso/${ssoToken}`
                        }
                      >
                        {" "}
                      </a>
                      {item.content}
                    </>
                  ) : (
                    <>
                      {item.content}
                      {item.description && (
                        <div className="description">{item.description}</div>
                      )}
                    </>
                  )}
                </Card>
              ))}
            </div>
          )}
        {!action && (
          <BackButton
            to="/velotax/exterior"
            className="report-exterior"
          />
        )}
        {action && (
          <Container>
            <Content>
              <Typography.Paragraph>Selecione o ano:</Typography.Paragraph>
              {action !== "anual-report" && (
                <Select
                  size="large"
                  options={yearOptions}
                  value={year.toString()}
                  onChange={onChangeYear}
                  placeholder="Selecione o ano"
                  style={{ minWidth: "150px" }}
                  getPopupContainer={(trigger) => trigger.parentElement}
                />
              )}
              <List
                loading={loading}
                dataSource={
                  data?.filter(
                    (item) =>
                      action === "anual-report" ||
                      item.year === year ||
                      item.year === currentYear
                  ) ?? []
                }
                itemLayout="horizontal"
                renderItem={(item, index) => {
                  // if(item.year === 2024 && action === "anual-report") return <></>
                  if (item.year === 2025 && action === "anual-report") return <></>
                  return  <List.Item
                  actions={[
                    <Button
                      type="text"
                      size="large"
                      href={item.url}
                      disabled={loadingLinks}
                      onClick={
                        () =>
                        {
                          if (!hasPlan.premium && !hasPlan.concierge && item.year === 2024) return;
                          toggleModal(item);
                          setItemToReport(item);
                        }
                      }
                      download={`Relatório-${item.year}-${zero(
                        item.month
                      )}.pdf`}
                    >
                      {!hasPlan.premium && !hasPlan.concierge && item.year === 2024 ? '' : 'Baixar'}
                      {loadingLinks ? (
                        <LoadingOutlined size={16} />
                      ) : (
                        <RiDownloadCloudLine size={16} />
                      )}
                      {(!hasPlan.premium && !hasPlan.concierge) && item.year === 2024 &&  <div style={{position: 'relative', right: '-30px'}}><AntButton
                        type="primary"
                        className="btn-premium"
                        icon={<AiOutlineLock size={18} />}
                        onClick={() => {
                          handlePlanModal();
                        }}
                      >
                        PREMIUM 
                      </AntButton></div>}
                     
                    </Button>,
                  ]}
                >
                  <Skeleton title={true} loading={item.loading} active>
                    <List.Item.Meta
                      title={
                        action !== "anual-report"
                          ? `${monthsExtended[item.month - 1]}`
                          : `${item.year}`
                      }
                    />
                  </Skeleton>
                </List.Item>
                }}
              />
              <Button
                type="text"
                size="large"
                onClick={() => navigate('/velotax/exterior')}
                style={{ marginTop: "0.5rem" }}
              >
                Voltar
              </Button>
            </Content>
          </Container>
        )}
        <Modal
          title="Aviso"
          maskClosable={true}
          visible={!!infoModal}
          onCancel={() => {
            toggleModal(null);
          }}
          footer={
            <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
              <Col span={24}>
                <MaterialButton
                  fullWidth
                  size="large"
                  color="primary"
                  disabled={loading}
                  variant="contained"
                  onClick={() => {
                    if (isMobile()) {
                      downloadAction(true);
                    }
                    else {
                      setModalConfirm(true);
                    }
                  }}
                >
                  {isMobile() ? 'Enviar informe por email' : 'Continuar'}
                </MaterialButton>
              </Col>
              <Col xs={24} sm={12}>
                <MaterialButton
                  fullWidth
                  size="small"
                  variant="text"
                  color="primary"
                  disabled={loading}
                  onClick={() => {
                    navigate("/velotax/exterior-historic");
                  }}
                >
                  Ir para calculadora de DARF
                </MaterialButton>
              </Col>
            </Row>
          }
        >
          <Typography.Paragraph style={{ marginTop: "-24px"  }}>
            <strong>
              Caso você tenha realizado operações de venda de ativos ou recebido
              cupom de bonds em {year},
            </strong>{" "}
            certifique-se de que todos os meses estejam com a situação "Regular"
            na Calculadora de DARF.
          </Typography.Paragraph>
        </Modal>
        <ModalConfirmMail
          closeFn={() => setModalConfirm(false)}
          visible={modalConfirm}
          action={(sendMail) => {
            downloadAction(sendMail);
            setModalConfirm(false);
          }}
        />
      </div>
    </ReportContainer>
  );
};
